const API_ERROR_MESSAGES: Record<string, string> = {
  USER_FROZEN: "账号已被冻结，无法登录",
};

export function parseApiError(
  errorData: unknown,
  fallback: string,
): { message: string; retryAfterSeconds?: number } {
  const detail = (errorData as { detail?: unknown } | null)?.detail;
  if (detail && typeof detail === "object" && detail !== null && "retry_after_seconds" in detail) {
    const d = detail as { message?: string; retry_after_seconds?: number };
    return {
      message: typeof d.message === "string" ? d.message : fallback,
      retryAfterSeconds:
        typeof d.retry_after_seconds === "number" ? d.retry_after_seconds : undefined,
    };
  }
  if (typeof detail === "string") {
    return { message: API_ERROR_MESSAGES[detail] ?? detail };
  }
  return { message: fallback };
}
